import { Component, OnInit, input, output } from '@angular/core';

@Component({
  selector: 'wr-year-select',
  standalone: false,
  template: `
    <nb-select [placeholder]="placeholder()" [selected]="selectedYear()" (selectedChange)="onYearChange($event)">
      @for (year of years; track year) {
        <nb-option [value]="year">{{ year }}</nb-option>
      }
    </nb-select>
  `,
})
export class YearSelectComponent implements OnInit {
  selectedYear = input<number>(new Date().getFullYear());
  placeholder = input<string>('Jahr auswählen');
  selectedYearChange = output<number>();

  years: number[] = [];

  ngOnInit() {
    const currentYear = new Date().getFullYear();
    const startYear = 2024;
    for (let year = currentYear; year >= startYear; year--) {
      this.years.push(year);
    }
  }

  onYearChange(year: number) {
    this.selectedYearChange.emit(year);
  }
}
